// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AdminConfig from "../types/admin/AdminConfig.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function execute(json) {
  return DeccoUtils$Catalyst.resolveResult(AdminConfig.t_decode(json), "AdminConfigStateMapper.re");
}

export {
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
